import { z } from 'zod';
export const RuleAndPolicySearchSchema = z.object({
  search: z.string().optional(),
  peopleGroupId: z.string().optional(),
  deviceGroupId: z.string().optional()
});
export type RuleAndPolicySearch = z.infer<typeof RuleAndPolicySearchSchema>;